SparkleVersion = '3.41';